import React from 'react';

import { ManageContractsApp } from '../contractManagementContext';
import NewAddress from '../sections/NewAddress';
import HouseType from '../sections/HouseType';
import StartDate from '../sections/StartDate';
import NewContract from '../sections/NewContract';
import ChangePrimaryAddress from '../sections/ChangePrimaryAddress';
import ChangeAddressDate from '../sections/ChangeAddressDate';
import ExtraServices from '../sections/ExtraServices';
import Billing from '../sections/Billing';
import MultipleOwners from '../sections/MultipleOwners';

export const MoveContinue: React.FunctionComponent = () => {
  const { changePrimaryAddress, newAddress, houseType } = ManageContractsApp.useState();

  return (
    <>
      <NewAddress />
      {newAddress && (
        <>
          <HouseType />
          {houseType && (
            <>
              <ChangePrimaryAddress />
              {changePrimaryAddress && <ChangeAddressDate />}
              <NewContract />
              <StartDate />
              <ExtraServices />
              <Billing />
              <MultipleOwners />
            </>
          )}
        </>
      )}
    </>
  );
};

export default MoveContinue;
